import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import '../styles/Servicepg.css';

import serviceVideo from '../assets/vid1.mp4';
import img1 from '../assets/building.jpg';
import img2 from '../assets/parralex13.jpg';
import img3 from '../assets/Pic-18.jpeg';
import img4 from '../assets/slide5.jpg';
import img5 from '../assets/slide6.jpg';

const Servicepg = () => {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <div className="servicepg-container">
      <video className="background-video" autoPlay muted loop playsInline>
        <source src={serviceVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="servicepg-content">
        <motion.div
          className="servicepg-left"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >

          <h1>ELECTRICAL SERVICES</h1>
          <p>
            We offer expert engineering design, equipment rental, transformer oil filtration,
            and reliable manpower services tailored to your needs.
          </p>
        </motion.div>

        <motion.div
          className="servicepg-right"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          <div className="image-merge-container">
            <img className="merged-img img1" src={img1} alt="Service 1" />
            <img className="merged-img img2" src={img2} alt="Service 2" />
            <img className="merged-img img3" src={img3} alt="Service 3" />
            <img className="merged-img img4" src={img4} alt="Service 4" />
            <img className="merged-img img5" src={img5} alt="Service 5" />
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Servicepg;
